import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that ensures an end date is after a start date
 * @param startDateControlName - The name of the start date control in the form
 * @returns ValidatorFn that validates the end date is after the start date
 */
export function dateAfterStartValidator(startDateControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const endDate = new Date(control.value);
    const startDateControl = control.parent?.get(startDateControlName);
    const startDate = startDateControl?.value;

    if (!startDate) {
      return null;
    }

    const startDateObj = new Date(startDate);

    if (isNaN(endDate.getTime())) {
      return { invalidDate: true };
    }

    if (endDate <= startDateObj) {
      return { dateAfterStart: true };
    }

    return null;
  };
}

/**
 * Validator that ensures a start date is before an end date
 * @param endDateControlName - The name of the end date control in the form
 * @returns ValidatorFn that validates the start date is before the end date
 */
export function dateBeforeEndValidator(endDateControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    const startDate = new Date(control.value);
    const endDateControl = control.parent?.get(endDateControlName);
    const endDate = endDateControl?.value;

    if (!endDate) {
      return null;
    }

    const endDateObj = new Date(endDate);

    if (isNaN(startDate.getTime())) {
      return { invalidDate: true };
    }

    if (startDate >= endDateObj) {
      return { dateBeforeEnd: true };
    }

    return null;
  };
}
